export default class chart {
    constructor() {
        return {
            restrict: 'E',
            template: '<canvas></canvas>',
            replace: true,
            scope: {
                data: '=',
                options: '='
            },
            controller: ['$scope', '$element', '$attrs', ($scope, $element, $attrs) => {
                let ctx = $element[0].getContext('2d');
                let chart = new Chart(ctx);
                let chartCreated;
                setDefaultOptions();

                $scope.$watch('data', (newVal) => {
                    if (! newVal) {
                        return;
                    }

                    var dataClone = angular.copy($scope.data);
                    var datasetsToUse = [];

                    angular.forEach($scope.data.datasets, (dataSet) => {
                        if (! dataSet.hidden) {
                            datasetsToUse.push(dataSet);
                        }
                    });

                    dataClone.datasets = datasetsToUse;

                    if (chartCreated) {
                        chartCreated.destroy();
                    }

                    switch ($attrs.type) {
                        case 'line':
                            chartCreated = chart.Line(dataClone, $scope.options);
                            break;
                        case 'bar':
                            chartCreated = chart.Bar($scope.data, $scope.options);
                            break;
                        case 'pie':
                            chartCreated = chart.Pie($scope.data, $scope.options);
                    }
                }, true);

                function setDefaultOptions() {
                    Chart.defaults.global.scaleFontSize = 14;
                    Chart.defaults.global.scaleFontFamily = 'Lato';
                    Chart.defaults.global.scaleFontColor = '#262950';
                    Chart.defaults.global.multiTooltipTemplate = "<%= datasetLabel %>: <%= value %>";
                    Chart.defaults.global.tooltipTitleFontFamily = 'Lato';
                    Chart.defaults.global.tooltipFontFamily = 'Lato';
                    Chart.defaults.global.pointDotRadius = 4;
                    Chart.defaults.global.pointDotStrokeWidth = 2;
                    Chart.defaults.global.scaleBeginAtZero = true;
                    Chart.defaults.global.tooltipFillColor = 'rgba(38,41,80,0.8)';
                }
            }]
        }
    }

};
